import Rect from 'react';
import { useSelector } from 'react-redux';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import { Col } from '../../../bootstrap';
import { PortalTrigger } from '../../../common/Portal.jsx';
import { FaIcon } from '../../../common/Icons.jsx';
import { Modal } from '../../../common/Modal.jsx';
import styles from '../base/CommonSettings.module.scss';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import WidgetTitleSettings from '../../settings_sidebar/WidgetTitleSettings.jsx';

function InfoDialog({ title, info }) {
  return (
    <Modal title={title} size="m" hideButtons>
      <div style={{whiteSpace: 'pre-line'}}>
        {info}
      </div>
    </Modal>
  );
};


function RiskGaugeWidgetSettings({ widgetId }) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const risk_context = useSelector(state => state.dashboard.widgets[widgetId].settings?.risk_context);

    return (<>
      <hr />      
      <CollapsibleSection title={I18n.t('content_settings')}>
        <div className={styles['settings-section']}>
            <WidgetTitleSettings widgetId={widgetId} />
            <div className={`${styles['settings-option']} context-selection}`}>
              <fieldset>
                  <label>{I18n.t('context_selection')}</label>
                  <Col size='xs-12'>
                  <input type='radio' name='none' checked={!risk_context} onChange={(e) => setAttribute("settings.risk_context", null)} /> {I18n.t('default')}<br />
                  </Col>
                  <Col size='xs-12'>
                  <input type='radio' name='fund' checked={risk_context === 'fund'} onChange={(e) => setAttribute("settings.risk_context", "fund")} />
                  {' '}{I18n.t('risk_management_context_fund')}
                  <PortalTrigger
                      label={<FaIcon type="info" />}
                      btnProps={{ type: "default", size: "xs", className: "ml-1" }}
                      portalProps={{
                      component: InfoDialog,
                      title: I18n.t('risk_management_context_fund_setting_title'),
                      info: I18n.t('risk_management_context_fund_setting_info'),
                      }}
                  />
                  <br />
                  </Col>
                  <Col size='xs-12'>
                  <input type='radio' name='portfolio' checked={risk_context === 'portfolio'} onChange={(e) => setAttribute("settings.risk_context", "portfolio")} />
                  {' '}{I18n.t('risk_management_context_portfolio')}
                  <PortalTrigger
                      label={<FaIcon type="info" />}
                      btnProps={{ type: "default", size: "xs", className: "ml-1" }}
                      portalProps={{
                      component: InfoDialog,
                      title: I18n.t('risk_management_context_portfolio_setting_title'),
                      info: I18n.t('risk_management_context_portfolio_setting_info'),
                      }}
                  />
                  <br />
                  </Col>
              </fieldset>
            </div>
        </div>
      </CollapsibleSection>
    </>)
}

export default RiskGaugeWidgetSettings;
